<template>
  <div class="container">
    <!--头部导航栏-->
    <vhead style="padding: 0 "></vhead>
    <!--中间内容-->
    <transition  name="fade-transform" mode="out-in">
        <router-view ></router-view>
    </transition>
    <!--底部导航栏-->
    <vfooter></vfooter>
  </div>
</template>

<script>
  import vhead from '../components/kheader/kheader'
  import vfooter from '../components/foot/foot'
  export default {
    name: "indexPanel",
    data(){
      return{
        interval:null,
      }
    },
    computed: {
      VToken() {
        let bool = true;
        if (this.$store.state.userInfo.VToken) {
          bool=false
        }
        return bool;
      }
    },
    components:{
      vhead,vfooter
    },
  }
</script>

<style scoped type="text/css">


</style>



// WEBPACK FOOTER //
// src/components/indexPanel.vue